<div [formGroup]="formGroup" style="display: flex; flex-direction: row; gap: 10px;">
    <mat-form-field style="width: 150px;">
        <mat-label>Country</mat-label>
        <input matInput [matAutocomplete]="CountryCodeAuto" formControlName="pct_countrycode"
            (input)="filterKeywords($event)" [value]="this.formGroup.controls['pct_countrycode'].value">
        <mat-autocomplete #CountryCodeAuto="matAutocomplete" (optionSelected)="selectKeyword($event)">
            <mat-option *ngFor="let entry of filteredcountryCodes" [value]="entry.cod_alpha2">
                <div class="option-primary">{{ entry.cod_alpha2 }}</div>
                <div class="option-secondary">
                    {{ entry.cod_countrycode }} | {{ entry.cod_countryname }}
                </div>
            </mat-option>
        </mat-autocomplete>

    </mat-form-field>

    <mat-form-field style="flex: 1 1 auto;">
        <mat-label>Phone number</mat-label>
        <input matInput formControlName="pct_callbacknumber"
            [value]="this.formGroup.controls['pct_callbacknumber'].value">
    </mat-form-field>

</div>